import _ from 'lodash';

import { lsFilters } from '../filters';

function getScheduleServiceName({ schedule, nameOnly = false }) {
    const { service, type } = schedule;

    if (type === 'paw') {
        // short circuit paws do not have a service object
        return nameOnly ? 'Cleanup' : 'Pre-authorized Cleanup';
    }

    if (type === 'instant_quote') {
        const iqType = schedule[type].type;

        return schedule.instant_quote[iqType].service.name;
    }

    if (type === 'qualityassurance') {
        return nameOnly
            ? lsFilters.titleCase({ text: schedule.qualityassurance.service.name })
            : `Fix for ${lsFilters.titleCase({ text: schedule.qualityassurance.service.name })}`;
    }

    if (type === 'manualquote') {
        return nameOnly
            ? lsFilters.titleCase({ text: schedule.manualquote.service.name })
            : `Quote for ${lsFilters.titleCase({ text: schedule.manualquote.service.name })}`;
    }

    return lsFilters.titleCase({ text: service.name });
}

function getScheduleStatus({ schedule }) {
    const { type, status } = schedule;

    if (type !== 'manualquote') {
        return status;
    }

    const validMQStatusValues = {
        new: true,
        ready: true,
        priced: true,
        rejected: true,
        expired: true,
        authorized: true,
    };
    const mqStatus = _.get(schedule, 'manualquote.status');

    return validMQStatusValues[mqStatus] ? mqStatus : schedule.status;
}

function getPreviousScheduleEvent({ schedule }) {
    // switching to camelcase for sanity
    const scheduleEvents = schedule.scheduleevents;
    const scheduleEventCount = _.size(scheduleEvents);

    const nextEventScheduledOrPending =
        schedule.next_eventstatus === 'scheduled' || schedule.next_eventstatus === 'pending';
    // if there are no scheduleEvents, or next one is scheduled/pending and there is less than two there's no way previous service exists
    if (!scheduleEventCount || (nextEventScheduledOrPending && scheduleEventCount < 2)) {
        return null;
    }

    // if next eventstatus isn't scheduled or pending it qualifies as the 'previous' service
    if (!nextEventScheduledOrPending) {
        return _.last(scheduleEvents);
    }

    // defensively get second to last scheduleEvent
    return _.get(scheduleEvents, `[${scheduleEventCount - 2}]`, null);
}

// eslint-disable-next-line import/prefer-default-export
export const lsScheduleHelpers = {
    getScheduleServiceName,
    getScheduleStatus,
    getPreviousScheduleEvent,
};
